import * as types from "types";

// Used to put the thread in the back of the line if it is undefined
const TEN_YEARS_AGO = new Date(
  Date.now() - 10 * 365 * 24 * 60 * 60 * 1000
).toISOString();

export function sortThreadsByDate(chatThreads: types.ChatThread[]) {
  return [...chatThreads].sort((threadA, threadB) => {
    const timeA = threadA.timestamp ?? TEN_YEARS_AGO;
    const timeB = threadB.timestamp ?? TEN_YEARS_AGO;

    return timeA > timeB ? -1 : timeA < timeB ? 1 : 0;
  });
}
